import React, { useState, useRef, useEffect } from "react";
import en from "react-phone-number-input/locale/en.json";

const CustomCountrySelect = ({ value, onChange, options }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState("");
  const wrapperRef = useRef(null);
  const menuRef = useRef(null);
  const resetTimerRef = useRef(null);

  const countryOptions = options.filter((opt) => opt.value);
  const filteredOptions = countryOptions.filter((opt) =>
    (en[opt.value] || opt.label || "")
      .toLowerCase()
      .startsWith(search.toLowerCase())
  );

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setIsOpen(false);
        setSearch("");
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (isOpen && menuRef.current) {
      menuRef.current.focus();
    }
  }, [isOpen]);

  const handleKeyDown = (e) => {
    if (e.key === "Escape") {
      setIsOpen(false);
      setSearch("");
      return;
    }
    if (e.key === "Backspace") {
      setSearch((prev) => prev.slice(0, -1));
      return;
    }
    if (e.key.length === 1 && /[a-zA-Z]/.test(e.key)) {
      setSearch((prev) => prev + e.key);

      if (resetTimerRef.current) clearTimeout(resetTimerRef.current);
      resetTimerRef.current = setTimeout(() => setSearch(""), 1200);
    }
  };

  return (
    <div className="country-select-wrapper" ref={wrapperRef}>
    <button
        type="button"
        className="country-select-trigger"
        onClick={() => setIsOpen((prev) => !prev)}
      >
        {value ? (
          <img
            src={`https://flagcdn.com/w20/${value.toLowerCase()}.png`}
            alt=""
            width="18"
          />
        ) : (
          <span>🏳️</span>
        )}
    </button>
    <span
        className="country-select-arrow"
        onClick={() => setIsOpen((prev) => !prev)}
      >
        ▾
    </span>

      {isOpen && (
        <div
          className="address-suggestions-menu country-suggestions-menu"
          ref={menuRef}
          tabIndex={-1}
          onKeyDown={handleKeyDown}
        >
          {filteredOptions.length === 0 && (
            <div className="address-suggestion-item text-muted">
              No match found
            </div>
          )}
          {filteredOptions.map((opt) => (
            <div
              key={opt.value}
              className={`address-suggestion-item d-flex align-items-center gap-2 ${
                opt.value === value ? "active" : ""
              }`}
              onClick={() => {
                onChange(opt.value);
                setIsOpen(false);
                setSearch("");
              }}
            >
              <img
                src={`https://flagcdn.com/w20/${opt.value.toLowerCase()}.png`}
                alt=""
                width="18"
              />
              <span>{en[opt.value] || opt.label}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomCountrySelect;